module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 53
// module chunks = 0 1 2 5 8 10 15 16 24 30 45 47